/* Share row. Added by Oleg @ IAKOE.
   <ts-share> wires the Copy-link button (clipboard + a brief "Copied" flash) and the
   native share button (Web Share API, hidden if the device has no share sheet). The
   plain social links are normal <a> targets and need no JS. */

class TsShare extends HTMLElement {
  connectedCallback() {
    this.copyBtn = this.querySelector('[data-share-copy]');
    this.nativeBtn = this.querySelector('[data-share-native]');

    if (this.copyBtn) this.copyBtn.addEventListener('click', () => this.copy());

    if (this.nativeBtn) {
      if (!navigator.share) {
        this.nativeBtn.hidden = true;
      } else {
        this.nativeBtn.addEventListener('click', () => this.share());
      }
    }
  }

  async copy() {
    const url = this.copyBtn.getAttribute('data-share-copy');
    try {
      if (navigator.clipboard) await navigator.clipboard.writeText(url);
      else this.legacyCopy(url);
    } catch (e) {
      this.legacyCopy(url);
    }
    this.flash();
  }

  legacyCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  flash() {
    const tag = this.copyBtn.querySelector('[data-share-copied]');
    if (!tag) return;
    tag.hidden = false;
    this.copyBtn.classList.add('is-copied');
    clearTimeout(this._t);
    this._t = setTimeout(() => {
      tag.hidden = true;
      this.copyBtn.classList.remove('is-copied');
    }, 1600);
  }

  async share() {
    try {
      await navigator.share({
        title: this.nativeBtn.getAttribute('data-title') || document.title,
        url: this.nativeBtn.getAttribute('data-url') || location.href,
      });
    } catch (e) {
      /* user cancelled — ignore */
    }
  }
}

if (!customElements.get('ts-share')) customElements.define('ts-share', TsShare);
